import logoDa from 'assets/logos/logo-da.png'
import logoEs from 'assets/logos/logo-es.png'
import logoFr from 'assets/logos/logo-fr.png'
import logoSv from 'assets/logos/logo-sv.png'

import { FranceLogo } from 'components/Header/components/icons/France'
import { JunoLogo } from 'components/Header/components/icons/Juno'
import { KarnovLogo } from 'components/Header/components/icons/Karnov'
import { SpanishLogo } from 'components/Header/components/icons/Spanish'

import { Language } from 'types/Api'

export type Logo = {
  url: string
  width: number
  height: number
}

export type RegionalLogo = {
  component: React.FC | undefined
  regionLogo: Logo | undefined
}

const brandingMap: Record<Language, RegionalLogo> = {
  fr: {
    component: FranceLogo,
    regionLogo: { url: logoFr, width: 132, height: 40 },
  },
  es: {
    component: SpanishLogo,
    regionLogo: { url: logoEs, width: 171, height: 40 },
  },
  da: {
    component: KarnovLogo,
    regionLogo: { url: logoDa, width: 128, height: 40 },
  },
  no: {
    component: KarnovLogo,
    regionLogo: { url: logoDa, width: 128, height: 40 },
  },
  nn: {
    component: KarnovLogo,
    regionLogo: { url: logoDa, width: 128, height: 40 },
  },
  sv: {
    component: JunoLogo,
    regionLogo: { url: logoSv, width: 154, height: 40 },
  },
}

export const getRegionalLogo = (language: Language): RegionalLogo =>
  brandingMap[language] ?? { component: undefined, regionLogo: undefined }
